<div class="box">
    <div class="box-content">
        <div class="pepites columns is-multiline">
            @if ((infoWithPepitesList?.contenu?.length || 0) > 0) {
                @for (pepite of infoWithPepitesList.contenu; track pepite) {
                    <div class="column is-4">
                        <span class="text has-text-weight-bold">{{ pepite.title }}</span>
                        <span [innerHTML]="pepite.pepites"></span>
                    </div>
                }
            }
        </div>
        <a class="link has-centered mt-1 is-flex" (click)="view()">*&nbsp;Voir les destinations en Europe</a>
        @if (infoWithPepitesList?.alert_content) {
            <div class="alert has-body mt-1 mb-0" [ngClass]="infoWithPepitesList.alert_bg || 'is-info'">
                <span class="icon">
                    <i [ngClass]="infoWithPepitesList.alert_icon || 'tri-infos-circle'" aria-hidden="true"></i>
                </span>
                <div class="body">
                    @if (infoWithPepitesList.alert_title) {
                        <div class="title is-level-3 is-loaded">{{ infoWithPepitesList.alert_title }}</div>
                    }
                    <p class="text is-loaded">
                        {{ infoWithPepitesList.alert_content }}
                    </p>
                </div>
            </div>
        }
    </div>
</div>
